import PropTypes from 'prop-types'
import { Component } from 'react'

import BusyOverlay from 'components/common/BusyOverlay'
import Text from 'components/common/Text'
import log from 'log'
import theme from 'theme'

export default class Content extends Component {
  static propTypes = {
    children: PropTypes.node,
    isLoading: PropTypes.bool,
    hasError: PropTypes.bool,
    errorMessage: PropTypes.string
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidCatch(error) {
    log.error(error)
  }

  state = {
    hasError: false
  }

  render() {
    const { hasError, errorMessage, isLoading, children, ...rest } = this.props

    return hasError || this.state.hasError ? (
      <ErrorContent message={errorMessage} />
    ) : (
      <div
        css={{
          paddingTop: theme.space[5],
          paddingBottom: theme.space[5],
          paddingLeft: theme.space[4],
          paddingRight: theme.space[4],
          maxWidth: theme.bp[3],
          display: 'flex',
          flexDirection: 'column',
          flex: 1,

          [theme.mq[2]]: {
            paddingRight: theme.space[7],
            paddingLeft: theme.space[7]
          }
        }}
        {...rest}
      >
        {isLoading ? <BusyOverlay shown /> : children}
      </div>
    )
  }
}

function ErrorContent({ message, ...rest }) {
  return (
    <div
      css={{
        paddingTop: theme.space[5],
        paddingBottom: theme.space[5],
        paddingRight: theme.space[7],
        paddingLeft: theme.space[7],
        maxWidth: theme.bp[3]
      }}
      {...rest}
    >
      <Text as="h5">{message}</Text>
    </div>
  )
}

ErrorContent.propTypes = {
  message: PropTypes.string
}

ErrorContent.defaultProps = {
  message: "We've encountered an error on this page. Please try again later."
}
